import React, { useState } from 'react';
import LanguageSwitcherContext from '../contexts/LanguageSwitcherContext';

const LanguageSwitcherProvider = ({ baseUrl, children }) => {
  const [href, setHref] = useState(baseUrl);

  return (
    <LanguageSwitcherContext.Provider
      value={{ languageSwitcherHref: href, setLanguageSwitcherHref: (path) => setHref(baseUrl + path) }}
    >
      {children}
    </LanguageSwitcherContext.Provider>
  );
};

export default LanguageSwitcherProvider;
